import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useParams,useNavigate } from "react-router-dom";
import Select from "react-select";

export const AdminAthleteEditDynamicStrengthWorkoutCircuit = () => {
  const navigate = useNavigate();
  const { staff } = useStaffAuthContext();
  const { id,athlete_id } = useParams();

  const [athleteName, setAthleteName] = useState("");
  const [error, setError] = useState("");
  const [loading,setLoading] = useState(false);
 
  const [selectedExercises, setSelectedExercises] = useState([]); // State to store selected exercises for Superset
  const [sets, setSets] = useState([{ reps: 0, weight: 0, weight_unit: "%",goal: '< 0.5 m/s (Absolute Strength)' }]);
  const [restDetails, setRestDetails] = useState("");
  const [notes, setNotes] = useState("");


 const [exerciseOptions, setExerciseOptions] = useState([]);

 useEffect(() => {
    const fetchAllData = async () => {
      try {
        const response = await fetch(`${API_URL.GET_ATHLETE_BY_ID}${athlete_id}`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${staff.token}`,
            },
          });
  
          const data = await response.json();
  
          if (!response.ok) {
            setError(data.error || "Failed to fetch athlete details");
            return;
          }
  
          setAthleteName(data.firstname + " " + data.lastname); // Adjust based on actual response structure
        // Fetch exercise options
        const exerciseResponse = await fetch(`${API_URL.SELECT_STRENGTH_EXERCISE_ALL}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        });
        const exerciseData = await exerciseResponse.json();
        if (!exerciseResponse.ok) {
          setError(exerciseData.error || "Failed to fetch exercises");
          return;
        }
        const exercises = exerciseData.exercises.map(exercise => ({
          value: exercise._id,  // Adjust this field based on your response structure
          label: exercise.title,  // Adjust this field based on your response structure
        }));
        setExerciseOptions(exercises);
  
      // Fetch workout superset data
      const workoutResponse = await fetch(`${API_URL.GET_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_CIRCUIT}${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
      });
      const workoutData = await workoutResponse.json();
      if (!workoutResponse.ok) {
        setError(workoutData.error || 'Failed to fetch workout data');
        return;
      }

      // Now handling multiple exercise IDs for a superset
      const selectedExercisesList = exercises.filter(option =>
        workoutData.circuit.exercise_ids.includes(option.value)
      );

      setSelectedExercises(selectedExercisesList); // Set the selected exercises for the superset
      setSets(workoutData.circuit.sets); // Assuming `sets` are part of the superset data
      setRestDetails(workoutData.circuit.rest_details);
      setNotes(workoutData.circuit.notes);
      setLoading(false);

      } catch (error) {
        setError("An error occurred while fetching data.");
      }
    };
  
    fetchAllData();  // Invoke the combined fetch function
  }, [athlete_id, staff.token]);

  const handleSetChange = (index, field, value) => {
    const newSets = [...sets];
    newSets[index][field] = value;
    setSets(newSets);
  };

  const addSet = () => {
    if (sets.length > 0) {
      const lastSet = sets[sets.length - 1]; // Get the last set
      setSets([...sets, { ...lastSet }]); // Spread the last set's data into a new object
    } else {
      setSets([{ reps: 0, weight: 0, weight_unit: "%", goal: '< 0.5 m/s (Absolute Strength)' }]); // Default set if no sets exist
    }
  };

  const removeSet = (index) => {
    setSets(sets.filter((_, i) => i !== index));
  };


  const handleSaveCircuit = async (e) => {
    e.preventDefault();

     // Prepare the exercise data
     const circuit = {
   
          exercise_ids: selectedExercises.map(exercise => exercise.value),   // Exercise IDs selected from the dropdown
          sets: sets.map(set => ({
            reps: set.reps,                // Reps value for the set
            weight: set.weight,            // Weight value for the set
            weight_unit: set.weight_unit,  // Weight unit (kg, lbs, etc.)
            goal: set.goal                 // Goal for the set (strength, hypertrophy, etc.)
          })),
          rest_details:restDetails,           // Rest details (from input field)
          notes     
        };
                // Notes (from input field)
         // Store the data in the state (for debugging or later use)
    //setSubmittedData(exerciseData);
    submitForm(API_URL.EDIT_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_CIRCUIT + id,circuit);
    };


  const submitForm = async (url, body) => {

    console.log(body);

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      if (!response.ok) {
        alert(data.error || "Failed to create item.");
      } else {
        alert("Exercise Saved successfully!");
       
      }
    } catch (err) {
      alert("An error occurred while saving the exercise.");
    }
  };
  

  return (
    <div className="flex h-screen">
    
        <StaffSideMenu />
  

      <div className="w-1/2 p-4">
      <button
            onClick={() => navigate(-1)}
            className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Go Back
          </button>
        <h1 className="text-2xl font-bold mb-4">Edit Static Strength Workout Circuit</h1>
        {error && <p className="text-red-500">{error}</p>}
        {!error && athleteName && (
          <h2 className="text-xl font-semibold mb-4">Athlete: <span className="text-green-600">{athleteName}</span></h2>
        )}

            <section className="mb-8">  
            <form onSubmit={handleSaveCircuit} className="space-y-6 bg-white p-6 shadow-md rounded">
              <div className="mb-4">
                <label htmlFor="exercises" className="block text-sm font-medium text-gray-700">Select Exercises</label>
               
                <Select
                  id="exerciseId"
                  options={exerciseOptions}
                  value={selectedExercises} // Array of selected options
                  onChange={setSelectedExercises} // `setSelectedExercises` should handle the array directly
                  placeholder="Select Exercises"
                  isMulti // Enable multi-select
                  getOptionLabel={(e) => e.label}
                  getOptionValue={(e) => e.value}
                  required
                  className="w-full"
                  isDisabled={true}
                />
        
              </div>
              <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">Add Set Details</label>
                  {sets.map((set, index) => (
                    <div key={index} className="grid grid-cols-5 gap-2 items-center mb-2">
                      <div>
                        <label htmlFor={`reps-${index}`} className="text-sm">Reps</label>
                        <input
                          id={`reps-${index}`}
                          type="number"
                          placeholder="Reps"
                          value={set.reps}
                          onChange={(e) => handleSetChange(index, "reps", e.target.value)}
                          required
                          className="w-full border rounded px-2 py-1"
                        />
                      </div>
                      <div>
                        <label htmlFor={`weight-${index}`} className="text-sm">Weight</label>
                        <input
                          id={`weight-${index}`}
                          type="number"
                          placeholder="Weight"
                          value={set.weight}
                          onChange={(e) => handleSetChange(index, "weight", e.target.value)}
                          required
                          className="w-full border rounded px-2 py-1"
                        />
                      </div>
                      <div>
                        <label htmlFor={`unit-${index}`} className="text-sm">Unit</label>
                        <select
                          id={`unit-${index}`}
                          value={set.weight_unit}
                          onChange={(e) => handleSetChange(index, "weight_unit", e.target.value)}
                          className="w-full border rounded px-2 py-1"
                        >
                          <option value="%">%</option>
                          <option value="lbs">lbs</option>
                          <option value="Hide">Hide</option>
                        </select>
                      </div>
                      <div>
                        <label htmlFor={`goal-${index}`} className="text-sm">Goal</label>
                        <select
                          id={`goal-${index}`}
                          value={set.goal}
                          onChange={(e) => handleSetChange(index, "goal", e.target.value)}
                          className="w-full border rounded px-2 py-1 min-w-[90px] md:min-w-[90px]"
                        >
                          <option value="< 0.5 m/s (Absolute Strength)">&lt; 0.5 m/s (Absolute Strength)</option>
                          <option value="0.5 - 0.75 m/s (Accelerative Strength)">0.5 - 0.75 m/s (Accelerative Strength)</option>
                          <option value="0.75 - 1 m/s (Strength Speed)">0.75 - 1 m/s (Strength Speed)</option>
                          <option value="1 - 1.3 m/s (Speed Strength)">1 - 1.3 m/s (Speed Strength)</option>
                          <option value="> 1.3 m/s (Starting Strength)">&gt; 1.3 m/s (Starting Strength)</option>
                          <option value="> 2 m/s (Speed)">&gt; 2 m/s (Speed)</option>
                        </select>
                      </div>
                      <div className="flex items-center h-full">
                        <button
                          type="button"
                          onClick={() => removeSet(index)}
                          className="text-red-500 font-bold"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                <div className="flex justify-end">
                      <button type="button" onClick={addSet} className="text-blue-500 font-bold mt-2">
                        Add Set
                      </button>
                </div>     
             </div>


                <div className="mb-4">
                  <label htmlFor="restDetails" className="block text-sm font-medium text-gray-700">Rest Details</label>
                  <textarea
                    id="restDetails"
                    placeholder="Enter Rest Details"
                    value={restDetails}
                    onChange={(e) => setRestDetails(e.target.value)}
                    className="w-full border rounded px-3 py-2"
                    rows="3"
                  ></textarea>
                </div>
                <div className="mb-4">
                  <label htmlFor="notes" className="block text-sm font-medium text-gray-700">Notes</label>
                  <textarea
                    id="notes"
                    placeholder="Enter Notes"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    className="w-full border rounded px-3 py-2"
                    rows="4"
                  ></textarea>
                </div>
                <div className="flex justify-center">
                  <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded">
                    Save Circuit
                  </button>
                </div>     
              </form>
          </section>
      </div>
    </div>
  );
};
